export default __webpack_public_path__ + "002f8577f65f92e5164229924c838d13.png";